import styled from '@emotion/styled';
import { BodyLarge, BodySmall } from '../../../styles';
import { shouldForwardProps } from '../../../utils';

const AuthorName = styled(BodyLarge, shouldForwardProps)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const TimeDistance = styled(BodySmall, shouldForwardProps)<{ italic: boolean }>`
    overflow: hidden;
    text-overflow: ellipsis;
    font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
`;

export { AuthorName, TimeDistance };
